import React from 'react';
import cx from 'classnames';
import styles from './CardLabel.less';

type LabelColor =
  | 'black'
  | 'blue'
  | 'green'
  | 'lime'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'red'
  | 'sky'
  | 'yellow'
  | 'none';

type LabelPattern =
  | 'striped'
  | 'transparent'
  | 'slant-right'
  | 'slant-left'
  | 'checkered'
  | 'StripeDiagonal'
  | 'WaveSquare'
  | 'StripeVertical'
  | 'DotsChecker'
  | 'GrooveDiagonal'
  | 'StripeHorizontal'
  | 'BrickDiagonal'
  | 'Scale'
  | 'BrickHorizontal'
  | 'BrickVertical';

interface CardLabelProps {
  className?: string;
  color?: LabelColor | null;
  pattern?: LabelPattern | null;
}

export const CardLabel: React.FC<CardLabelProps> = ({
  className,
  color,
  pattern,
  children,
}) => {
  const labelClasses = cx(
    className,
    styles.label,
    children && styles.expanded,
    color === 'blue' && styles.blue,
    color === 'green' && styles.green,
    color === 'lime' && styles.lime,
    color === 'sky' && styles.sky,
    color === 'orange' && styles.orange,
    color === 'pink' && styles.pink,
    color === 'purple' && styles.purple,
    color === 'red' && styles.red,
    color === 'yellow' && styles.yellow,
    color === 'black' && styles.black,
    pattern === 'striped' && styles.striped,
    pattern === 'slant-left' && styles.slantLeft,
    pattern === 'slant-right' && styles.slantRight,
    pattern === 'checkered' && styles.checkered,

    pattern === 'StripeDiagonal' && styles.StripeDiagonal,
    pattern === 'WaveSquare' && styles.WaveSquare,
    pattern === 'StripeVertical' && styles.StripeVertical,
    pattern === 'DotsChecker' && styles.DotsChecker,
    pattern === 'GrooveDiagonal' && styles.GrooveDiagonal,
    pattern === 'StripeHorizontal' && styles.StripeHorizontal,
    pattern === 'BrickDiagonal' && styles.BrickDiagonal,
    pattern === 'Scale' && styles.Scale,
    pattern === 'BrickHorizontal' && styles.BrickHorizontal,
    pattern === 'BrickVertical' && styles.BrickVertical,
  );
  return <span className={labelClasses}>{children}</span>;
};
